"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _jobs = _interopRequireDefault(require("./jobs"));

var _specialVariables = _interopRequireDefault(require("./specialVariables"));

var _default = [_jobs.default, _specialVariables.default];
exports.default = _default;